import {
  PortalLinksByRoles,
  type PortalLink,
} from '@/shared/components/navigation/NavigationConstants'
import {
  ADMIN_ROLE,
  DOCTOR_ROLE,
  PATIENT_ROLE,
  SUPPORT_ROLE,
} from '@/lib/constants'

export type AccountNavigationLink = {
  title: string
  href: string
}

export function buildAccountLinks(
  roles: readonly string[],
): AccountNavigationLink[] {
  let links: PortalLink[] = []

  if (roles.includes(PATIENT_ROLE)) {
    links = PortalLinksByRoles.patient
  } else if (roles.includes(DOCTOR_ROLE)) {
    links = PortalLinksByRoles.doctor
  } else if (roles.includes(ADMIN_ROLE)) {
    links = PortalLinksByRoles.superadmin
  } else if (roles.includes(SUPPORT_ROLE)) {
    links = PortalLinksByRoles.support
  }

  if (links.length > 0) {
    return links.map(({ title, href }) => ({ title, href }))
  }

  return [{ title: 'Portal', href: '/portal' }]
}
